import React from 'react';
import * as Api from "../../utils/api";
const GLOBAL_IMAGE_URL = Api.imageGlobalUrl;

export default class CourseItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render(){
        const _this = this;
        let type = _this.props.type;
        let item = _this.props.item;
        let index = _this.props.index;
        let isFree = Number(item.isFree);
        let isBuy = Number(item.isBuy);
        return (
            <div>
                <div className="course-item" onClick = { _this.courseDetail.bind(_this,item) }>
                    <div className="proxy-image">
                        <img src={ GLOBAL_IMAGE_URL+ item.iconUrl }/>
                        <div className="proxy-text">{ item.playCount }人在学</div>
                        <div className="proxy-innerbg"></div>
                    </div>
                    <div className="courseInfo">
                        <div className="info">
                            <p className="p-title">
                                { item.expertName }&nbsp;&nbsp;&nbsp;&nbsp;{ item.title }</p>
                            <p className="p-name">{ item.courseName }</p>
                        </div>
                        <div>
                            {
                                type === "free"
                                ? (isFree !== 0 ? <div className="buyedStatus">免费</div> : null)
                                : ( isBuy !== 0 
                                    ?   <div className="buyedStatus">已购</div> 
                                    :   <p className="p-price">
                                            <span className="price-flag">￥</span>
                                            <span className="price">{ item.price }</span>
                                            <del>
                                                <span >原价&nbsp;&nbsp;</span>
                                                <span className="price-delfalg">￥</span>
                                                <span>{ item.oldPrice }</span>
                                            </del>
                                        </p>)
                            }                          
                        </div>
                    </div>
                </div>
                {
                    _this.props.lineLimit === (index+1)
                    ? null
                    :  <div className="separator-line"></div>
                }
            </div>
        );
    }
    courseDetail(item){
        const _this = this;
        _this.props.courseListHandler(item);
    }
}
